export const getFloorDescription = floor => {
  return `${floor}º piso`;
};
